import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Events} from "ionic-angular";
import {ApiProvider} from "../api/api";
import {UserStateProvider} from "../user-state/user-state";

/*
  Generated class for the ChatStateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChatStateProvider {

  unreadChat: boolean;
  unreadPartnerChat: boolean;
  unreadTopics: Array<{id: string, forumId: string}>;
  unreadForums: Map<string, number>;
  unreadLocalChat: boolean;
  forumResponseCount: number;
  initLoad: boolean = false;

  constructor(public events: Events, public api: ApiProvider, public userState: UserStateProvider) {
    this.startInterval();

    this.events.subscribe('message:received', (data: {conversation_id: string}) => {
      console.log(data);
      if(data.conversation_id.length > 40) {
        this.unreadPartnerChat = true;
      } else {
        this.unreadChat = true;
      }
      this.unreadLocalChat = true;
      this.checkState();
    });
    this.events.subscribe('chat:opened', (data: {id: string}) => {
      if(data.id.length > 40) {
        this.unreadPartnerChat = false;
        this.unreadLocalChat = false;
        this.checkState();
      } else {
        this.unreadChat = false;
        this.unreadLocalChat = false;
        this.checkState();
      }
    });
    this.events.subscribe('forum:topicViewed', (data: {id: string}) => {
      if(!this.unreadTopics) {
        return ;
      }

      let foundIndex = this.unreadTopics.map(row => {return row.id}).indexOf(data.id);
      if(foundIndex > -1) {
        let object = this.unreadTopics[foundIndex];
        let currentForumUnreadCount = this.unreadForums.get(object.forumId);
        if(currentForumUnreadCount > 1) {
          this.unreadForums.set(object.forumId, currentForumUnreadCount-1);
        } else {
          this.unreadForums.delete(object.forumId);
        }

        this.unreadTopics.splice(foundIndex, 1);

        this.checkState();
      }

      this.events.publish('forum:topicViewedProcessed');
    })
  }

  incResponseCount() {
    this.forumResponseCount++;
    this.events.publish('forum:response', {count: this.forumResponseCount});
  }

  _loadData() {
    this.api.callGet('/users/'+this.userState.user.id+'/chatState').subscribe((data: {chat: boolean, partner: boolean, forumResponseCount: number, topics: Array<{id: string, forumId: string}>}) => {
      this.unreadChat = data.chat;
      this.unreadPartnerChat = data.partner;
      this.unreadTopics = data.topics;
      this.unreadForums = new Map<string, number>();

      this.forumResponseCount = data.forumResponseCount;

      for(var l in data.topics) {
        let record = data.topics[l];

        if(!this.unreadForums.get(record.forumId)) {
          this.unreadForums.set(record.forumId, 1);
        } else {
          this.unreadForums.set(record.forumId, this.unreadForums.get(record.forumId)+1);
        }
      }

      if (!this.initLoad) {
        this.unreadLocalChat = (data.chat || data.partner);
        this.initLoad = true;
      }

      this.checkState();
    });
  }

  isForumUnread(id: string) {
    return this.unreadForums.get(id);
  }
  isTopicUnread(id: string) {
    return this.unreadTopics.filter(row => {
      return row.id == id;
    }).length > 0;
  }

  startInterval() {
    this._loadData();
    setInterval(() => {
      this._loadData();
    }, 30000);
  }

  getUnreadTopicsCount() {
    return this.unreadTopics.length;
  }


  currentUnreadState: boolean;
  checkState() {
    console.log(this);

    if(!this.unreadChat && !this.unreadTopics.length && !this.unreadLocalChat) {
      this.currentUnreadState = false;
    } else {
      this.currentUnreadState = true;
    }

    if(this.currentUnreadState) {
      this.events.publish('chat-state:unread');
    } else {
      this.events.publish('chat-state:read');
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/chat-state/chat-state.ts